<template>
  <div class="about">
    <h1>This is an about page</h1>
    <h2>{{openId}}</h2>
  </div>
</template>

<script>
export default {
  name: 'About',
  data () {
    return {
      openId: this.$route.query.code
    }
  },
  mounted: function () {
    this.openId = this.$route.query.code
    console.log(this.openId)
  }
}
</script>
